<ng-container *transloco="let t; read: 'org-settings-call-list'">
  <p-messages severity="info">
    <ng-template pTemplate>
      <div class="ml-2">{{ t('description') }}</div>
    </ng-template>
  </p-messages>
</ng-container>
<app-call-list-table-editor></app-call-list-table-editor>
